// src/pages/TestAuthPage.jsx
import React, { useEffect } from 'react';
import { supabase } from './supabaseClient';

const TestAuthPage = () => {
    useEffect(() => {
        const checkSession = async () => {
            console.log('--- Running direct session check ---');
            const { data: { session }, error } = await supabase.auth.getSession();
            if (error) {
                console.error('Error fetching session:', error);
            }
            console.log('Session found:', session);
            if (session) {
                console.log('User ID:', session.user.id);
            }
            console.log('-----------------------------------');
        };

        checkSession();
    }, []);

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Auth Test Page</h1>
            <p>Check the console for session details.</p>
        </div>
    );
};

export default TestAuthPage;